const paymentTypesLabel = {
  zero: "رایگان",
  wallet: "کیف_پول",
  cash: "نقدی",
  cod: "پرداخت_بعد_از_تحویل",
  zarinpal: "زرینپال",
  sadad: "سداد",
  pna: "نوین پرداخت",
  bpMellat: "به پرداخت"
}

export default paymentTypesLabel